var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth, persistent: "" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title"),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.items,
                          "item-text": "key",
                          "item-value": "key",
                          label: "Select Currency Kind(s):",
                          "return-object": "",
                          multiple: "",
                          "small-chips": "",
                          "deletable-chips": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model,
                          callback: function ($$v) {
                            _vm.model = $$v
                          },
                          expression: "model",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.forms.length
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-simple-table",
                            {
                              staticStyle: {
                                "max-height": "300px",
                                "margin-top": "16px",
                                overflow: "auto",
                              },
                              attrs: { dense: "" },
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v("Currency"),
                                  ]),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "text-left",
                                      staticStyle: { width: "120px" },
                                    },
                                    [_vm._v("Percentage")]
                                  ),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.forms, function (f) {
                                  return _c("tr", { key: f.kind.key }, [
                                    _c("td", [_vm._v(_vm._s(f.kind.key))]),
                                    _c(
                                      "td",
                                      [
                                        _c("v-text-field", {
                                          staticStyle: { "margin-top": "-4px" },
                                          attrs: {
                                            type: "number",
                                            min: "1",
                                            max: "100",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          on: {
                                            keydown: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              $event.stopPropagation()
                                            },
                                          },
                                          model: {
                                            value: f.percentage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                f,
                                                "percentage",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "f.percentage",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startResize.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }